
import { commandCounsellorGroup } from "./command-counsellor-group-details/command-counsellor-group.module";

import { CommandCounsellorGroupService } from "./command-counsellor-group.service";

export const commandCounsellorGroupTM = angular
  .module("components.command-counsellor-group", [
    commandCounsellorGroup    
  ])
  .service("CommandCounsellorGroupService", CommandCounsellorGroupService).name;


// WEBPACK FOOTER //
// ./src/app/components/command-counsellor-group/command-counsellor-group.module.js